(function () {
  angular.module("akitabox.desktop.components.filterBar", []);
})();
